<template>
    <div class="searchbox">
        <input @focus="onFocus" ref="input" @blur="onBlur" @keydown="onKeyDown" v-model="searchText"
                :placeholder="$t('searchBox.placeholder')" role="searchbox" :aria-label="$t('searchBox.ariaLabel')">
        <font-awesome-icon icon="search" @click="onClick"></font-awesome-icon>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'addressSearch',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      searchText: ''
    };
  },
  props: {
    value: String
  },
  watch: {
    searchText(newVal) {
      this.$emit('input', newVal);
    }
  },
  mounted() {
    this.searchText = this.value;
  },
  methods: {
    onFocus() {
      this.$emit('focus');
    },
    onBlur() {
      this.$emit('blur');
    },
    onKeyDown(evt) {
      if (evt.key === 'Escape') {
        this.searchText = '';
      } else if (evt.key === 'Enter') {
        this.$emit('search');
      } else {
        this.$emit('keydown', evt);
      }
    },
    onClick() {
      this.$emit('search');
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .searchbox {
        width: calc(100% - 40px);
        border: $search-border;
        border-radius: 5px;
        padding: 5px 5px;
        margin: 5px 20px;
        input {
            width: calc(100% - 30px);
            border: none;
            outline: none;
        }
    }
</style>
